/* eslint-disable react-hooks/exhaustive-deps */
import {
  Grid,
  FormControl,
  Typography,
  TextField,
  InputAdornment,
  FormHelperText,
  Box,
} from "@mui/material";
import Button from "@mui/material/Button";
import {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useTheme } from "@mui/material/styles";
import AutoCompleteInput from "../../../Components/FormComponents/AutoCompleteInput";
import { useTranslation } from "react-i18next";
import IconExpandInformation from "Components/Result/icons/IconExpandInformation";
import IconHideInfomation from "Components/Result/icons/IconHideInfomation";
import { get } from "lodash";
import { SelectOption, CarCompanyInfo, CarInfoModel, ChildRef } from "./type";
import {
  getCarInfoCompany,
  getCarInfoModel,
  getCarManufacturedYears,
  getCarVersion,
  getListOrigin,
  getKmTraveledSuggestion,
  getCarOptionByVersion,
} from "../../MainBody/api";
import { listHideCarBrand } from "./constants";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { minDate, maxDate } from "Common/common";
import useStyles from "../useStyles";
import { OTHER } from "./constants";

interface CarFormProps {
  onValueChange: (value: string) => void;
  dataFormImage: any;
  setDataFromImage: any;
}

const CarForm = forwardRef<ChildRef, CarFormProps>(
  ({ onValueChange, dataFormImage, setDataFromImage }, ref) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const theme = useTheme();

    const handleTrigger = () => {
      resetSelect();
    };

    useImperativeHandle(ref, () => ({
      triggerAction: handleTrigger,
    }));

    const [selectedCarCompany, setSelectedCarCompany] = useState<SelectOption>({
      id: "",
      label: "",
    });
    const [selectedModel, setSelectedModel] = useState<SelectOption>({
      id: "",
      label: "",
    });
    const [selectedVersion, setSelectedVersion] = useState<SelectOption>({
      id: "",
      label: "",
    });
    const [selectedOption, setSelectedOption] = useState<SelectOption>({
      id: "",
      label: "",
    });
    const [selectedOrigin, setSelectedOrigin] = useState<SelectOption>({
      id: "",
      label: "",
    });

    const [startDate, setStartDate] = useState<Dayjs | null>(null);

    const vehicleInspectionOcrIdRef = useRef(0);

    const [selectedManufactured, setSelectedManufactured] =
      useState<SelectOption>({ id: "", label: "" });
    const [onRoad, setOnRoad] = useState<string>("");

    const [listCarCompany, setListCarCompany] = useState<SelectOption[]>([]);
    const [listCarInfoModel, setListCarInfoModel] = useState<SelectOption[]>(
      [],
    );
    const [listOrigin, setListOrigin] = useState<SelectOption[]>([]);
    const [listOption, setListOption] = useState<SelectOption[]>([]);
    const [listVersion, setListVersion] = useState<SelectOption[]>([]);
    const [listManufactured, setListManufactured] = useState<SelectOption[]>(
      [],
    );

    const [openCarModel, setOpenCarModel] = useState(false);
    const [openCarManufactured, setOpenCarManufactured] = useState(false);
    const [openCarVersion, setOpenCarVersion] = useState(false);
    const [openCarOption, setOpenCarOption] = useState(false);
    const [openCarOrigin, setOpenCarOrigin] = useState(false);
    const [expandMore, setExpandMore] = useState(false);

    const resetSelect = () => {
      setSelectedCarCompany({ id: "", label: "" });
      setSelectedModel({ id: "", label: "" });
      setSelectedVersion({ id: "", label: "", key: "" });
      setSelectedManufactured({ id: "", label: "" });
      vehicleInspectionOcrIdRef.current = 0;
      setDataFromImage(null);
      setStartDate(null);
    };

    useEffect(() => {
      (async () => {
        const getCarInfo: CarCompanyInfo[] = await getCarInfoCompany(1000);
        let newListOption: SelectOption[] = [];
        if (getCarInfo && getCarInfo.length > 0) {
          getCarInfo.forEach((company) => {
            const option: SelectOption = {
              id: company.carCompanyId,
              label: company.vehicleBrandName,
            };

            newListOption.push(option);
          });
          listHideCarBrand.forEach((element) => {
            newListOption = newListOption.filter(
              (option) => option.id !== element,
            );
          });

          setListCarCompany(newListOption);
        }

        if (dataFormImage && dataFormImage.predictedCarCompany) {
          const nameOfCarCompany = dataFormImage.predictedCarCompany;
          const findCarCompany = newListOption.find(
            (company) => company?.label === nameOfCarCompany,
          );

          if (findCarCompany) {
            const vehicleInspectionOcrId = get(
              dataFormImage,
              "vehicleInspectionOcrId",
            );
            setSelectedCarCompany(findCarCompany);
            vehicleInspectionOcrIdRef.current = vehicleInspectionOcrId;
          }
        }
      })();
    }, [listHideCarBrand, dataFormImage]);

    useEffect(() => {
      if (selectedCarCompany?.id !== "") {
        setSelectedModel({ id: "", label: "" });
        setSelectedVersion({ id: "", label: "" });
        setSelectedManufactured({ id: "", label: "" });
        setSelectedOption({ id: "", label: "" });
        setSelectedOrigin({ id: "", label: "" });
        setListCarInfoModel([]);

        (async () => {
          const listCarInfoModel: CarInfoModel[] = await getCarInfoModel(
            selectedCarCompany?.id || "",
            100,
          );
          const newListOption: SelectOption[] = [];

          if (listCarInfoModel && listCarInfoModel.length > 0) {
            listCarInfoModel.forEach((model) => {
              const option: SelectOption = {
                id: model.carModelId,
                label: model.carModelName,
              };
              newListOption.push(option);
            });

            setListCarInfoModel(newListOption);
          }
          if (dataFormImage && dataFormImage.predictedCarModel) {
            const nameOfCarModel = dataFormImage.predictedCarModel;
            const findCarModel = newListOption.find(
              (model) => model?.label === nameOfCarModel,
            );
            if (findCarModel) {
              setSelectedModel(findCarModel);
            }
          }
        })();
      } else {
        setSelectedModel({ id: "", label: "" });
        setSelectedOption({ id: "", label: "" });
        setSelectedOrigin({ id: "", label: "" });
        setListOption([]);
      }
    }, [selectedCarCompany, dataFormImage]);

    useEffect(() => {
      if (selectedModel?.id !== "") {
        setSelectedVersion({ id: "", label: "" });
        setSelectedManufactured({ id: "", label: "" });
        setSelectedOrigin({ id: "", label: "" });
        setListManufactured([]);

        (async () => {
          const listManufacturedYears: number[] = await getCarManufacturedYears(
            selectedCarCompany.id,
            selectedModel.id,
          );
          const newListManufactured: SelectOption[] = [];
          if (listManufacturedYears && listManufacturedYears.length > 0) {
            listManufacturedYears.forEach((manufactured) => {
              const option: SelectOption = {
                id: manufactured.toString(),
                label: manufactured.toString(),
              };
              newListManufactured.push(option);
            });
            setListManufactured(newListManufactured);
          }

          if (dataFormImage && dataFormImage?.predictedYear) {
            const nameOfManufactured = dataFormImage?.predictedYear;
            const findManufactured = newListManufactured.find(
              (manufactured) =>
                manufactured?.label === nameOfManufactured.toString(),
            );
            if (findManufactured) setSelectedManufactured(findManufactured);
          }
        })();
      } else {
        setSelectedManufactured({ id: "", label: "" });
        setSelectedOrigin({ id: "", label: "" });
      }
    }, [selectedModel, selectedCarCompany, dataFormImage]);

    useEffect(() => {
      if (selectedManufactured?.id !== "") {
        setSelectedVersion({ id: "", label: "" });
        setSelectedOrigin({ id: "", label: "" });
        setStartDate(null);
        setListVersion([]);

        (async () => {
          const listVersion = await getCarVersion(
            selectedCarCompany?.id,
            selectedModel.id,
            selectedManufactured.id,
          );
          const newListOption: SelectOption[] = [];
          if (listVersion && listVersion.length > 0) {
            listVersion.forEach((version: any) => {
              const option: SelectOption = {
                id: version.carVersionId,
                label: version.carVersionName,
                key: version.carVersionKey,
                fuel: version.carFuelName,
              };
              newListOption.push(option);
            });
            setListVersion(newListOption);
          }

          if (dataFormImage && dataFormImage?.predictedCarVersion) {
            const nameOfCarVersion = dataFormImage?.predictedCarVersion;
            const findCarVersion = newListOption.find(
              (version) => version?.label === nameOfCarVersion,
            );
            if (findCarVersion) setSelectedVersion(findCarVersion);
          }
        })();
        (async () => {
          const kmTraveld = await getKmTraveledSuggestion(
            selectedManufactured.id,
          );
          setOnRoad(kmTraveld.kmTraveledSuggest);
        })();
      } else {
        setSelectedVersion({ id: "", label: "" });
        setSelectedOrigin({ id: "", label: "" });
        setStartDate(null);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
      selectedManufactured,
      selectedModel,
      selectedCarCompany,
      dataFormImage,
    ]);

    useEffect(() => {
      if (selectedVersion?.id !== "") {
        setSelectedOrigin({ id: "", label: "" });
        setListOrigin([]);
        setListOption([]);

        (async () => {
          const listOrigin = await getListOrigin({
            carCompany: selectedCarCompany.label,
            carModel: selectedModel.label,
            carVersion: selectedVersion.label,
            year: parseInt(selectedManufactured.id, 10),
          });
          const newListOption: SelectOption[] = [];
          if (listOrigin && listOrigin.length > 0) {
            listOrigin.forEach((origin: any) => {
              const option: SelectOption = {
                id: origin.originId,
                label: origin.originName,
              };
              newListOption.push(option);
            });
            setListOrigin(newListOption);
            if (listOrigin.length >= 1)
              setSelectedOrigin({
                id: listOrigin[0].originId,
                label: listOrigin[0].originName,
              });
          }
        })();
        (async () => {
          const listCarOption = await getCarOptionByVersion(
            selectedCarCompany.label,
            selectedModel.label,
            selectedVersion.label,
            parseInt(selectedManufactured.id, 10),
          );
          const newListOption: SelectOption[] = [];
          if (listCarOption && listCarOption.length > 0) {
            listCarOption.forEach((item: any) => {
              const option: SelectOption = {
                id: item.optionId,
                label: item.optionName,
                key: item.optionKey,
              };
              newListOption.push(option);
            });
            setListOption(newListOption);
            if (listCarOption.length >= 1)
              setSelectedOption({
                id: listCarOption[0].optionId,
                label: listCarOption[0].optionName,
                key: listCarOption[0].optionKey,
              });
          } else {
            setListOption([]);
          }
        })();
      } else {
        setListOrigin([]);
        setListOption([]);
        setSelectedOrigin({ id: "", label: "" });
        setSelectedOption({ id: "", label: "", key: "" });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedVersion]);

    useEffect(() => {
      onValueChange(
        JSON.stringify({
          company: selectedCarCompany,
          model: selectedModel,
          manufactureyear: selectedManufactured,
          version: selectedVersion,
          originId: selectedOrigin,
          kmTraveled: onRoad,
          optionKey: selectedOption,
          ...(startDate && { date: startDate.format("YYYY-MM-DD") }),
        }),
      );
    }, [
      onValueChange,
      selectedCarCompany,
      selectedModel,
      selectedManufactured,
      selectedVersion,
      selectedOption,
      selectedOrigin,
      onRoad,
      startDate,
    ]);

    //Check upload image vehicle inspection and fill to auto complete done => show message for each case

    const handleChangeOnRoad = (event: React.ChangeEvent<HTMLInputElement>) => {
      const road = parseFloat(event.target.value);
      if (road < 0) {
        setOnRoad("0");
      } else if (road > 999999) {
        setOnRoad("999999");
      } else {
        setOnRoad(event.target.value);
      }
    };

    const isValidate =
      selectedCarCompany?.id !== "" &&
      selectedModel?.id !== "" &&
      selectedVersion?.id !== "" &&
      selectedManufactured?.id !== "";

    return (
      <>
        <Grid item md={5.5} xs={12}>
          <AutoCompleteInput
            label={t("form.selection.brand.title")}
            listOption={listCarCompany}
            onChange={setSelectedCarCompany}
            value={selectedCarCompany}
            placeholder={t("form.selection.brand.placeholder")}
            onClose={() => {
              setOpenCarModel(true);
            }}
            onOpen={() => {
              setOpenCarModel(false);
              setOpenCarVersion(false);
            }}
            hidden
          />
        </Grid>

        <Grid item md={5.5} xs={12}>
          <AutoCompleteInput
            label={t("form.selection.model.title")}
            listOption={listCarInfoModel}
            onChange={setSelectedModel}
            value={selectedModel}
            disabled={selectedCarCompany?.id === ""}
            disabledReset={selectedCarCompany?.id === OTHER}
            placeholder={t("form.selection.model.placeholder")}
            open={selectedCarCompany?.id !== "" && openCarModel}
            onClose={() => {
              setOpenCarModel(false);
              setOpenCarManufactured(true);
            }}
            onOpen={() => {
              setOpenCarModel(!openCarModel);
              setOpenCarManufactured(false);
              setOpenCarVersion(false);
            }}
            hidden
          />
        </Grid>

        <Grid item md={5.5} xs={12}>
          <AutoCompleteInput
            label={t("form.selection.manufacture-year.title")}
            listOption={listManufactured}
            onChange={setSelectedManufactured}
            value={selectedManufactured}
            disabled={selectedModel?.id === ""}
            disabledReset={selectedModel?.id === OTHER}
            placeholder={t("form.selection.manufacture-year.placeholder")}
            open={selectedModel?.id !== "" && openCarManufactured}
            onClose={() => {
              setOpenCarManufactured(false);
              setOpenCarVersion(true);
            }}
            onOpen={() => {
              setOpenCarManufactured(!openCarManufactured);
              setOpenCarVersion(false);
            }}
            hidden
          />
        </Grid>

        <Grid item md={5.5} xs={12}>
          <AutoCompleteInput
            label={t("form.selection.version.title")}
            listOption={listVersion}
            onChange={setSelectedVersion}
            value={selectedVersion}
            disabled={selectedManufactured?.id === ""}
            disabledReset={selectedManufactured?.id === OTHER}
            placeholder={t("form.selection.version.placeholder")}
            open={selectedManufactured?.id !== "" && openCarVersion}
            onClose={() => {
              setOpenCarVersion(false);
            }}
            onOpen={() => {
              setOpenCarVersion(!openCarVersion);
            }}
            hidden
          />
        </Grid>
        <Grid item md={5.5} xs={12}>
          <Box display="flex" flexDirection="column" gap={1} pt={2}>
            <Typography
              variant="body2"
              sx={{ color: theme.palette.mode === "dark" ? "white" : "black" }}
            >
              Tra cứu giá lịch sử
            </Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={startDate}
                onChange={(newValue) => setStartDate(newValue)}
                maxDate={dayjs(maxDate())}
                minDate={
                  selectedManufactured.id ===
                    new Date().getFullYear().toString() ||
                  selectedManufactured.id ===
                    (new Date().getFullYear() - 1).toString()
                    ? dayjs(`01/01/${selectedManufactured.id}`)
                    : dayjs(minDate())
                }
                disabled={!selectedManufactured.id}
                slotProps={{
                  field: { clearable: true },
                  textField: { size: "small" },
                }}
                format="DD/MM/YYYY"
                views={["year", "month", "day"]}
              />
            </LocalizationProvider>

            <Typography variant="caption" sx={{ color: "gray" }}>
              Chọn thời gian trong quá khứ để xem lại giá thị trường thời điểm
              đó.
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} md={5.5}>
          {listOption.length > 0 && (
            <AutoCompleteInput
              label="Option"
              listOption={listOption}
              onChange={setSelectedOption}
              value={selectedOption ?? { id: "", label: "", key: "" }}
              placeholder="Option"
              open={openCarOption}
              onClose={() => {
                setOpenCarOption(false);
              }}
              onOpen={() => {
                setOpenCarOption(true);
              }}
              hidden
            />
          )}
          <Typography
            variant="caption"
            sx={{
              color:
                theme.palette.mode === "dark" ? "rgb(33, 38, 44)" : "white",
            }}
          >
            Chọn thời gian trong quá khứ để xem lại giá thị trường thời điểm đó.
          </Typography>
        </Grid>
        <Grid item xs={12} md={12}>
          <Button
            className={classes.addingInfomationButton}
            onClick={() => setExpandMore(!expandMore)}
            variant="text"
            endIcon={
              !expandMore ? <IconExpandInformation /> : <IconHideInfomation />
            }
          >
            Thông tin bổ sung{" "}
          </Button>
        </Grid>
        {expandMore && (
          <>
            {listOrigin.length > 0 && (
              <Grid item xs={12} md={5.5}>
                <FormControl variant="standard" sx={{ minWidth: "100%" }}>
                  <AutoCompleteInput
                    label="Xuất xứ"
                    listOption={listOrigin}
                    onChange={setSelectedOrigin}
                    value={selectedOrigin ?? { id: "", label: "" }}
                    placeholder="Xuất xứ"
                    open={openCarOrigin}
                    onClose={() => {
                      setOpenCarOrigin(false);
                    }}
                    onOpen={() => {
                      setOpenCarOrigin(true);
                    }}
                    hidden
                  />
                  <FormHelperText> </FormHelperText>
                </FormControl>
              </Grid>
            )}
            <Grid item xs={12} md={5.5}>
              <FormControl variant="standard" sx={{ minWidth: "100%" }}>
                <Typography
                  variant="body2"
                  sx={{
                    color: theme.palette.mode === "light" ? "black" : "white",
                  }}
                >
                  Số km đã đi
                </Typography>
                <TextField
                  value={onRoad}
                  placeholder="Số km đã đi"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">Km</InputAdornment>
                    ),
                  }}
                  size="small"
                  onChange={handleChangeOnRoad}
                  type="number"
                />
                {selectedManufactured && selectedManufactured.id !== "" && (
                  <FormHelperText>
                    Đây là gợi ý số km đã đi trung bình theo tuổi xe của bạn
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
          </>
        )}
        <Grid item xs={12} md={12} display="flex" justifyContent="center">
          <Button
            className={classes.valueButton}
            style={{
              background: `${isValidate ? "#5768FF" : "#f0f0f0"}`,
              color: `${isValidate ? "#ffffff" : "#bdbdbd"}`,
            }}
            disabled={!isValidate}
            type="submit"
          >
            Tra cứu
          </Button>
        </Grid>
      </>
    );
  },
);

export default CarForm;
